// These are the themes for brands (e.g. TRUSS, GOAT, Depop) which are used in src/contexts/StyleContext.js

//These are Themes - they contain Palette and Component styling

/*
    [GOAT]
*/
export const theme_GOAT = {

}